import { Component, Input } from '@angular/core';
import { DeviceDto } from '../../../types/dtos/device.dto';
import { formatTimeAgo, getOnlineStatus } from '../../utils/date.util';

@Component({
  selector: 'app-last-activity',
  imports: [],
  templateUrl: './last-activity.html',
  styleUrl: './last-activity.css',
})
export class LastActivity {
  @Input()
  public device!: DeviceDto;

  public get lastActivity(): string {
    if (!this.device?.last_measurement_received_time) return '-';

    return formatTimeAgo(this.device.last_measurement_received_time);
  }

  public getOnlineStatus(): 'green' | 'orange' | 'red' {
    return getOnlineStatus(this.device);
  }
}
